module.exports = __webpack_public_path__ + "static/media/ibisLogo.681f4b1a.svg";